import { render, staticRenderFns } from "./recipe-summary-item.vue?vue&type=template&id=95298722&"
import script from "./recipe-summary-item.vue?vue&type=script&lang=js&"
export * from "./recipe-summary-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports